import type { Level } from "@serophin/nottldr-shared";
import { levelStyle } from "./levelStyles";

export type LevelDisplayProps = {
  level: Level;
  class?: string;
};

export const LevelDisplay = ({ level, class: className = "" }: LevelDisplayProps) => (
  <span class={`${levelStyle(level).text} font-semibold ${className}`}>{level.charAt(0).toUpperCase() + level.slice(1)}</span>
);
